module.exports = __webpack_public_path__ + "assets/img/Aerial View (Pine Grove).58426f50.jpg";